import "./MonitorAlarmTableDesktopView.scss";
import filter from "../../../common/images/filter.png";
import { ALARM_TYPE_FILTER, ALARM_PRIORITY_FILTER } from "../../../common/constant/common-constants";
import { convertUTCtoIST } from "../../../common/utils/CommonUtils";
import system_alert_svg from "../../../common/icons/svg/system_alert.svg";


export default function MonitorAlarmTableDesktopView({


    monitorConnected,


    tableRef,
    header,
    sortedEvents,
    selectedTypeFilter,
    selectedPriorityFilter,
    toggleFilterDropdown,
    filterDropdown,
    dropdownRef,
    handleFilterSelect,
    getPriority,
    isLoading,
}) {
    return (
        <div className="monitor-alarm-table-desktop">
            <div className="alarm-history-header-row">
                <div className="alarm-history-text">Event History</div>
                {monitorConnected && monitorConnected.isDemo && (
                    <div className="alarm-history-demo-note">
                        No events will sync during Demo Mode
                    </div>
                )}
            </div>
            <div className="alarm-history-data-container">
                <div ref={tableRef} className="alarm-table-container">
                    <table className="alarm-table">
                        <thead className="sticky">
                            <tr>
                                {header?.map((data, count) => {
                                    const canShowPriorityFilter =
                                        selectedTypeFilter === "PHYSIOLOGICAL" ||
                                        selectedTypeFilter === "TECHNICAL";

                                    const isPriorityColumn = data === "PRIORITY";
                                    const isTypeColumn = data === "TYPE";
                                    const shouldShowFilter =
                                        isTypeColumn || (isPriorityColumn && canShowPriorityFilter);

                                    return (
                                        <th
                                            key={count}
                                            className="alarm-header"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                className="header-content"
                                                style={{
                                                    cursor: shouldShowFilter ? "pointer" : "default",
                                                }}
                                                onClick={
                                                    shouldShowFilter
                                                        ? () => toggleFilterDropdown(data)
                                                        : undefined
                                                }
                                            >
                                                <span className="alarm-header-label">{data}</span>
                                                {shouldShowFilter && (
                                                    <span className="filter-icon">
                                                        <img src={filter} alt="filter" />
                                                    </span>
                                                )}
                                            </div>

                                            {filterDropdown.open &&
                                                filterDropdown.column === data &&
                                                shouldShowFilter && (
                                                    <div
                                                        ref={dropdownRef}
                                                        className="alarm-filter-dropdown"
                                                    >
                                                        {(data === "TYPE"
                                                            ? ALARM_TYPE_FILTER
                                                            : ALARM_PRIORITY_FILTER
                                                        ).map((f) => {
                                                            const isSelected =
                                                                data === "TYPE"
                                                                    ? f.name === selectedTypeFilter
                                                                    : f.name === selectedPriorityFilter;

                                                            return (
                                                                <div
                                                                    key={f.id}
                                                                    className={`alarm-filter-dropdown__option${
                                                                        isSelected
                                                                            ? " alarm-filter-dropdown__option--selected"
                                                                            : ""
                                                                    }`}
                                                                    onClick={() => handleFilterSelect(f, data)}
                                                                    role="option"
                                                                    aria-selected={isSelected}
                                                                >
                                                                    {f.label}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>

                        <tbody>
                            {sortedEvents?.map((row, count) => {
                                if (!row) return null;

                                const activeTime = row?.activeTime || '';
                                const resolveTime = row?.resolvedTime || '';

                                const activeIST = convertUTCtoIST(activeTime);
                                const resolveIST = convertUTCtoIST(resolveTime);
                                const priorityData = row?.priority ? getPriority(row.priority) : { color: '', textColor: '', icon: '' };
                                const color = row?.status === 'active' ? priorityData.color : '';
                                const textColor = row?.status === 'active' ? priorityData.textColor : '';

                                let type = '';
                                if (row?.type) {
                                    type = row.type
                                        .split(' ')
                                        .map((t) => t ? t[0].toUpperCase() + t.substring(1).toLowerCase() : '')
                                        .join(' ');
                                }

                                if (!row?.message) return null;

                                return (
                                    <tr key={count} className={color ? "alarm-row--live" : undefined}>
                                        <td
                                            className="alarm-cell alarm-cell--type"
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                            }}
                                        >
                                            {type || "-"}
                                        </td>
                                        <td
                                            className="alarm-cell alarm-cell--priority"
                                            style={{ backgroundColor: color }}
                                        >
                                            <div className="alarm-priority">
                                                {priorityData.icon && (
                                                    <img
                                                        alt="priority icon"
                                                        src={priorityData.icon}
                                                        className="priority"
                                                    />
                                                )}
                                            </div>
                                        </td>
                                        <td
                                            className="alarm-cell alarm-cell--message"
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                            }}
                                        >
                                            {row.message || "-"}
                                        </td>
                                        <td
                                            className="alarm-cell alarm-cell--datetime"
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                            }}
                                        >
                                            <div className="alarm-datetime-time">{activeIST.time}</div>
                                            <div className="alarm-datetime-date">{activeIST.date}</div>
                                        </td>
                                        <td
                                            className="alarm-cell alarm-cell--datetime"
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                            }}
                                        >
                                            {resolveIST.time === "-" ? (
                                                <span className="alarm-datetime-unresolved">-</span>
                                            ) : (
                                                <>
                                                    <div className="alarm-datetime-time">{resolveIST.time}</div>
                                                    <div className="alarm-datetime-date">{resolveIST.date}</div>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {isLoading && (
                        <div className="spinner-container">
                            <div className="spinner"></div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
